import { RegionShared } from "@1games-ru/region-shared";
import clsx from "clsx";
import { imgLogo2 } from "@/shared/assets/img";

type Props = (typeof RegionShared.Cef.Requests.SetHudStateRequest)["serverInfo"] & {
  dynamicId?: number;
  staticId?: number;
  className?: string;
};

export default function HudServerInfo({
  onlineCount,
  projectName,
  staticId,
  dynamicId,
  className,
}: Props) {
  return (
    <div className={clsx("flex items-center gap-5", className)}>
      <div className="flex flex-col items-end gap-1">
        <div className="text-12 font-bold uppercase">{projectName} SERVER</div>
        <div className="flex items-center gap-2 text-white/70 ">
          <div className="text-14 font-medium">ID: {staticId}</div>
          <div className="h-2 w-[1px] bg-white/10" />
          <div className="text-14 font-medium">#{dynamicId}</div>
          <div className="h-2 w-[1px] bg-white/10" />
          <div className="text-12 font-bold uppercase">
            В ИГРЕ: <span className="text-14 text-white">{onlineCount}</span>
          </div>
        </div>
      </div>
      <img src={imgLogo2} alt="" className="h-7" />
    </div>
  );
}
